/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusscheduled2Inputs */

const en_crosspostingstatusscheduled2 = /** @type {(inputs: Crosspostingstatusscheduled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled`)
};

const de_crosspostingstatusscheduled2 = /** @type {(inputs: Crosspostingstatusscheduled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant`)
};

/**
* | output |
* | --- |
* | "Scheduled" |
*
* @param {Crosspostingstatusscheduled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusscheduled2 = /** @type {((inputs?: Crosspostingstatusscheduled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusscheduled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusscheduled2(inputs)
	return de_crosspostingstatusscheduled2(inputs)
});
export { crosspostingstatusscheduled2 as "crosspostingStatusScheduled" }